import * as authenticatedApi from './authenticated-api'
export { authenticatedApi }
